<template>
	<div>
		<notifications />
        <preloader v-if="isLoading"></preloader>
		<template-form
			title="Edit Payment"
			submitTxt="Update Payment"
			defaultFormType="edit"
			:fields="fields"
			:errors="fieldErrors"
			:invoices="invoices"
			:isLoading="isLoading"
			:editForm="true"
			:onSubmit="handleSubmit" />
	</div>
</template>

<script>
import Form from './Form.vue';
import { defaultFields, getBasePrice, defaultErrors } from "./helpers";
import { defaultListFields } from "../customers/helpers";
import { displayDate } from "../../helpers";
import Preloader from "../Preloader.vue";

export default {
	components: {
		'template-form': Form, Preloader
	},
	data() {
		return {
			isLoading: false,
			fields: defaultFields(),
			fieldErrors: defaultErrors(),
			invoices: [],
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			const receiptResponse = await axios.get(`/receipts/` + this.$route.params.id);
			this.fields = this.parseData(receiptResponse.data.data);

			const response = await axios.get('/invoices');
			this.invoices = response.data.data.map((value) => {return {...value, label: value.number + " " + value.title}});
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}

		this.isLoading = false;
	},
	methods: {
		async handleSubmit(fields) {
			this.fieldErrors = defaultErrors();
			this.isLoading = true;

			if (!this.validateInputs()) {
				this.isLoading = false;
				return;
			}

			try {
				var data = {
					...fields,
					invoice_id: fields.invoice_id.id
				}
				const response = await axios.patch(`/receipts/${this.$route.params.id}`, data);
				this.$notify({
					type: 'success',
					title: 'Payment Updated',
					text: 'You\'ve successfully updated the payment!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		parseData(item) {
			return {
				id: item.id,
				invoice_id: {
					...item.invoice,
					label: item.invoice.number + " " + item.invoice.title
				},
				number: item.number,
				date: displayDate(item.date),
				amount: item.amount,
				note: item.note,
			}
		},
		validateInputs() {
			
			return true;
		},
	}
}
</script>
